"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconGarageFilled = function IconGarageFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.49 35.57C33.4524 35.4743 33.3916 35.3895 33.313 35.3232C33.2344 35.2568 33.1406 35.2111 33.04 35.19L24.59 33.38C24.4387 33.3484 24.3058 33.2586 24.22 33.13L22.5 30.85C22.4799 30.8166 22.4522 30.7883 22.4192 30.7674C22.3863 30.7466 22.3488 30.7338 22.31 30.73L20.83 30.45C19.564 30.22 18.2848 30.0697 17 30V40.42H25C25.0831 41.1228 25.4212 41.7707 25.9502 42.2408C26.4792 42.7109 27.1623 42.9706 27.87 42.9706C28.5777 42.9706 29.2608 42.7109 29.7898 42.2408C30.3188 41.7707 30.6569 41.1228 30.74 40.42H32.83C32.975 40.4218 33.1163 40.3743 33.2307 40.2852C33.3452 40.1962 33.426 40.071 33.46 39.93C33.7027 39.0335 33.8831 38.1214 34 37.2C33.9034 36.6364 33.7318 36.0882 33.49 35.57ZM29.49 40.42C29.4185 40.7839 29.2229 41.1116 28.9365 41.3472C28.6501 41.5828 28.2908 41.7116 27.92 41.7116C27.5492 41.7116 27.1899 41.5828 26.9035 41.3472C26.6171 41.1116 26.4215 40.7839 26.35 40.42C26.3397 40.3136 26.3397 40.2064 26.35 40.1C26.35 39.6757 26.5186 39.2687 26.8186 38.9686C27.1187 38.6686 27.5257 38.5 27.95 38.5C28.3743 38.5 28.7813 38.6686 29.0814 38.9686C29.3814 39.2687 29.55 39.6757 29.55 40.1C29.5308 40.2094 29.5006 40.3166 29.46 40.42H29.49Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 10.5V42.5C9 42.6326 9.05268 42.7598 9.14645 42.8536C9.24021 42.9473 9.36739 43 9.5 43H14.5C14.6326 43 14.7598 42.9473 14.8536 42.8536C14.9473 42.7598 15 42.6326 15 42.5V18.5C15 18.3674 15.0527 18.2402 15.1464 18.1464C15.2402 18.0527 15.3674 18 15.5 18H34.5C34.6326 18 34.7598 18.0527 34.8536 18.1464C34.9473 18.2402 35 18.3674 35 18.5V42.5C35 42.6326 35.0527 42.7598 35.1464 42.8536C35.2402 42.9473 35.3674 43 35.5 43H40.5C40.6326 43 40.7598 42.9473 40.8536 42.8536C40.9473 42.7598 41 42.6326 41 42.5V10.5C41 10.3674 40.9473 10.2402 40.8536 10.1464C40.7598 10.0527 40.6326 10 40.5 10H9.5C9.36739 10 9.24021 10.0527 9.14645 10.1464C9.05268 10.2402 9 10.3674 9 10.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.5 20H18.5C17.6716 20 17 20.6716 17 21.5C17 22.3284 17.6716 23 18.5 23H31.5C32.3284 23 33 22.3284 33 21.5C33 20.6716 32.3284 20 31.5 20Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.5 25H18.5C17.6716 25 17 25.6716 17 26.5C17 27.3284 17.6716 28 18.5 28H31.5C32.3284 28 33 27.3284 33 26.5C33 25.6716 32.3284 25 31.5 25Z",
    fill: color
  }));
};

IconGarageFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconGarageFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconGarageFilled;
exports.default = _default;